<his-plam [hisDdKey]="dDKey">
	<div class="selectContainer">
		<p-autoComplete #content
			[(ngModel)]="selectedJournal"
            [suggestions]="filteredJournals"
            field="fullTitle"
			[size]="30"
			[minLength]="1"
			[forceSelection]="true"
			(completeMethod)="filterJournal($event)"
			(onSelect)="onSelectByAutocomplete()"
			(onClear)="onClear()"
			[hisDdKey]="dDKey">
		</p-autoComplete>
	</div>

	<div class="selectContainer">
		<his-search-select-popup
			[searchConfigFile]="moduleOptions.SEARCH_CONFIGURATION_FILENAME"
			[selectedOptions]="getJournals()"
			selectedOptionsIdColumn="Journal.id"
			[showDeleteButton]="false"
			[singleSelect]="true"
			(selectedOptionsChange)="onSelectBySearchPopup($event)">
			<div class="infoMessage">
				{{'fs.res.publication.journal.search.notFoundQuestion' | hisUi}}		
            </div>
            <a *ngIf="auth.hasAnyArray(moduleOptions.RIGHT_CREATE_FROM_MENU)" (click)="onBeforeNavigate()" [routerLink]="['/pub/journal/create/']" [queryParams]="{fromForm: true}" hisImage="context_add" class="transparent">
                <span>{{'fs.res.publication.journal.search.create' | hisUi}}</span>
            </a>			
		</his-search-select-popup>

		<!-- Zeitschrift bearbeiten -->
	    <a *ngIf="selectedJournal?.journal && auth.hasAny('RIGHT_FS_RES_PUBLICATION_EDIT_JOURNAL')" class="transparent"
			[routerLink]="['/pub/journal/edit/', selectedJournal.journal.id]" [queryParams]="{fromForm: true}"
			(click)="onBeforeNavigate()" hisImage="PENCIL">{{'fs.res.publication.journal.edit' | hisUi}}</a>

		<!-- Neue Zeitschrift anlegen -->
		<a *ngIf="auth.hasAny('RIGHT_FS_RES_PUBLICATION_CREATE_JOURNAL')" (click)="onBeforeNavigate()" [routerLink]="['/pub/journal/create/']" [queryParams]="{fromForm: true}" hisImage="context_add" class="transparent">
			<span>{{'fs.res.publication.journal.search.create' | hisUi}}</span>
		</a>

		<!-- Zusatz-Informationen -->
		<div *ngIf="selectedJournal?.journal" class="selectedContentInfo">
			<p *ngIf="selectedJournal.journal.shorttext">
				{{'fs.res.publication.Journal.abbreviation' | hisUi}}: {{selectedJournal.journal.shorttext}}
			</p>
			<p *ngIf="selectedJournal.journal.publisher && selectedJournal.journal.publisher.label">
				{{'fs.res.publication.Publisher' | hisUi}}: {{selectedJournal.journal.publisher.label}}
			</p>
			<!-- Nur den Identifier mit der höchsten Priorität anzeigen -->
			<!-- TODO Ist der erste wirklich der mit der höchsten Priorität? -->
			<p *ngIf="selectedJournal.journal.globalIdentifiers && selectedJournal.journal.globalIdentifiers.length>0">
				{{selectedJournal.journal.globalIdentifiers[0].globalIdentifierType.text}}: {{selectedJournal.journal.globalIdentifiers[0].identifier}}
			</p>
            <p *ngIf="selectedJournal.journal.peerReviewed && selectedJournal.journal.peerReviewed.defaulttext">
				<span>{{'fs.res.publication.Journal.peerReviewed' | hisUi}}: {{selectedJournal.journal.peerReviewed.defaulttext}}</span>
                <span *ngIf="!isWithoutPeerReviewProcess && selectedJournal.journal.peerReviewedBegin">, {{'fs.res.publication.journal.peerReviewed.since' | hisUi}} {{selectedJournal.journal.peerReviewedBegin | date: dateFormat}}</span>
			</p>
		</div>
	</div>
</his-plam>
